import { usePatientIdFromParams } from "../../../application";
import { PatientDetailPageV2 } from "../../../ui/pages/v2";

export function PatientDetailV2Route() {
  const patientId = usePatientIdFromParams();
  return <PatientDetailPageV2 patientId={patientId} />;
}
